(function () {
  'use strict';

  var FOCUSABLE = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  var drawer = null;
  var backdrop = null;
  var titleEl = null;
  var bodyEl = null;
  var closeBtn = null;
  var lastTrigger = null;
  var savedScrollY = 0;
  var isOpen = false;

  function build() {
    if (drawer) return;

    backdrop = document.createElement('div');
    backdrop.className = 'info-drawer__backdrop';
    backdrop.hidden = true;

    drawer = document.createElement('div');
    drawer.className = 'info-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-labelledby', 'info-drawer-title');
    drawer.hidden = true;

    var header = document.createElement('div');
    header.className = 'info-drawer__header';

    titleEl = document.createElement('h2');
    titleEl.className = 'info-drawer__title';
    titleEl.id = 'info-drawer-title';

    closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'info-drawer__close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML =
      '<svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true" focusable="false">' +
      '<path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.7" ' +
      'stroke-linecap="round" fill="none"/></svg>';

    bodyEl = document.createElement('div');
    bodyEl.className = 'info-drawer__body';

    header.appendChild(titleEl);
    header.appendChild(closeBtn);
    drawer.appendChild(header);
    drawer.appendChild(bodyEl);

    document.body.appendChild(backdrop);
    document.body.appendChild(drawer);

    closeBtn.addEventListener('click', close);
    backdrop.addEventListener('click', close);
    drawer.addEventListener('keydown', onDrawerKeydown);
  }

  function onDrawerKeydown(event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      event.stopPropagation();
      close();
      return;
    }
    if (event.key !== 'Tab') return;

    var items = drawer.querySelectorAll(FOCUSABLE);
    if (!items.length) {
      event.preventDefault();
      return;
    }
    var first = items[0];
    var last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function lockScroll() {
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.classList.add('info-drawer-open');
  }

  function unlockScroll() {
    document.body.classList.remove('info-drawer-open');
    document.body.style.top = '';
    window.scrollTo(0, savedScrollY);
  }

  function open(trigger, panel) {
    build();
    lastTrigger = trigger;

    titleEl.textContent =
      panel.getAttribute('data-panel-heading') || 'More information';
    bodyEl.innerHTML = '';
    var clone = panel.cloneNode(true);
    clone.removeAttribute('hidden');
    clone.removeAttribute('data-info-panel');
    while (clone.firstChild) bodyEl.appendChild(clone.firstChild);

    backdrop.hidden = false;
    drawer.hidden = false;
    lockScroll();

    var reveal = function () {
      backdrop.classList.add('is-open');
      drawer.classList.add('is-open');
    };
    if (window.requestAnimationFrame) requestAnimationFrame(reveal);
    setTimeout(reveal, 60);

    trigger.setAttribute('aria-expanded', 'true');
    isOpen = true;
    closeBtn.focus();
  }

  function close() {
    if (!isOpen || !drawer) return;
    isOpen = false;

    backdrop.classList.remove('is-open');
    drawer.classList.remove('is-open');

    if (lastTrigger) lastTrigger.setAttribute('aria-expanded', 'false');
    unlockScroll();

    var finish = function () {
      drawer.hidden = true;
      backdrop.hidden = true;
      if (lastTrigger) {
        lastTrigger.focus();
        lastTrigger = null;
      }
    };

    /* Wait for the slide-out, but never depend on transitionend firing — it
       does not fire if the element is display:none'd or the tab is hidden. */
    var done = false;
    var once = function () {
      if (done) return;
      done = true;
      finish();
    };
    drawer.addEventListener('transitionend', once, { once: true });
    setTimeout(once, 420);
  }

  function promote(card, panel) {
    if (card.hasAttribute('data-info-trigger')) return;
    card.setAttribute('data-info-trigger', '');
    card.setAttribute('role', 'button');
    card.setAttribute('tabindex', '0');
    card.setAttribute('aria-haspopup', 'dialog');
    card.setAttribute('aria-expanded', 'false');
    card.classList.add('has-info-panel');

    card.addEventListener('click', function (event) {
      /* A real link inside the card keeps its own behaviour. */
      if (event.target.closest('a[href], button')) return;
      open(card, panel);
    });

    card.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
      if (event.target.closest('a[href], button')) return;
      event.preventDefault(); /* stop Space scrolling the page */
      open(card, panel);
    });
  }

  function init() {
    var panels = document.querySelectorAll('[data-info-panel]');
    for (var i = 0; i < panels.length; i++) {
      var card = panels[i].closest('.multicolumn-card');
      if (card) promote(card, panels[i]);
    }
  }

  function safeInit() {
    try {
      if (!Element.prototype.closest) return;
      init();
    } catch (e) {
      /* Silent: the cards were never marked interactive, so nothing is broken. */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeInit);
  } else {
    safeInit();
  }

  document.addEventListener('shopify:section:load', safeInit);
})();
